import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { Player } from 'src/models/player.model';
import { Score } from 'src/models/score.model';
import { UserService } from 'src/services/user.service';
import { ScoreService } from './scores.service';



@Component({
  selector: 'scores',
  templateUrl: './scores.component.html',
  styleUrls: ['./scores.component.scss']
})
export class ScoresComponent implements AfterViewInit {
  public busy: boolean = true;
  public scores: Score[] = [];
  public player: Player = new Player();

  constructor(private authorizeService: AuthorizeService,
    private router: Router,
    private userSvc: UserService,
    private scoreSvc: ScoreService,
    http: HttpClient) {
  }

  ngAfterViewInit(): void {
    const p1 = this.userSvc.getUser();
    const p2 = this.scoreSvc.scores();
    forkJoin([p1, p2]).subscribe(
      (resp) => {
        this.player = new Player(resp[0]);
        this.scores.length = 0;
        resp[1].forEach(p => this.scores.push(new Score(p)));
        this.busy = false;
      },
      (err) => this.busy = false
    )
  }
}